
import Vue from "vue";
import Currency from "@/models/base/currency";
import {CurrencyService} from "@/services/currency-service";

export default Vue.extend({
	props: {
		currency: {
			type: Object as ()=>Currency,
			required: true
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		save() {
			CurrencyService.saveCurrency(this.currency);
			this.$emit("update");
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
